import { render } from "./Mp3Player2.vue?vue&type=template&id=d5ae6596&ts=true"
import script from "./Mp3Player2.vue?vue&type=script&lang=ts"
export * from "./Mp3Player2.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\vdmar\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__